import React, { useState, useEffect, useRef, setState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';


import ReactDatePicker from "react-datepicker";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactFlagsSelect from "react-flags-select";
import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import { DoModal, ModalContent } from "../../utils/Modal";

import './AddModCategory.css';
import AvatarSelect from '../../components/avatarSelect';

export default function AddModCategory(props) {

    const location = useLocation();

    const { register, handleSubmit, control, watch, setValue, formState: { errors }, reset } = useForm();

    const [updateCat, setUpdateCat] = useState(false);

    const [tailorShops, setTailorShops] = useState([]);
    const [tailorshop, setTailorShop] = useState({ tailorshop_id: "1", short_name: "YB" });
    const [selectedValue, setSelectedValue] = useState("1");

    const { catData, tailorshopSelect } = location.state || {};

    const navigate = useNavigate();
    const selectRef = useRef();

    const auth = useAuth();
    if (!auth.user) {
        auth.logOut();

    }

    const [isOpen, setIsopen] = useState(false);
    const showModal = () => setIsopen((prev) => !prev);


    const handleTailorShopSelect = (event) => {

        event.stopPropagation();

        setValue("owner", selectRef.current.value);

        let ts = tailorShops.find((element) => element.tailorshop_id === event.target.value);
        if (ts) {
            // console.log('TS:', ts);
            setTailorShop(ts);
            setSelectedValue(ts.tailorshop_id);



        }
    }



    const onSubmit = (data) => {

        if (!auth.user) {
            auth.logOut();
            return;
        }

        // data.preventDefault();
        data['tailorshop_id'] = tailorshop.tailorshop_id;

        if (!data['name']) {
            alert("Enter Category Name");
            return;
        }


        console.debug("DEBUG:", data);



        //console.log(data);
    }

    useEffect(() => {

        if (!auth.user) {
            auth.logOut();
            return;
        }

        //   alert("Here");

        let childData = {
            category_id: -1,
            category_parent: catData.category_id,
            name: "Child",
            remark: "",
            owner: catData.owner,
            state: 1,
            pos: 1,
            category_type: 'FabricCat'
        };

        reset(childData);



        fetch("/api/tailorshops/", {
            method: "GET",
            headers: getHeaders(auth),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                //getOrderItems(rowData2);
                //console.log(rowData);\

                rowData.push({ name: 'All', short_name: '*', tailorshop_id: 0 })
                setTailorShops(rowData);

                if (rowData.length >= 1) {
                    setTailorShop(rowData[0]);
                }
                setTimeout(() => { selectRef.current.value = tailorshopSelect }, 100)


            })
            .catch((error) => console.log(error));

    }, [props]);




    useEffect(() => {


        setValue("category_type", "FabricCat");
    }, [props]);


    if (!catData) {
        return <div>No data</div>;
    }

    return (
        <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Container className="p-9 ">
                    <Row style={{ width: "100%" }}>
                        <label className="form-select-label p-1" htmlFor="tailorshop"> Select Tailor Shop:</label>
                        <select className="form-select m-2 " aria-label="Tailor shop" style={{ height: "55px", width: "450px" }} id="tailorshop"
                            onChange={handleTailorShopSelect} ref={selectRef}>
                            {/* <option value="0" id="0" defaultValue>All</option> */}

                            {tailorShops.map((shop, idx) => {
                                return (
                                    <option value={shop.tailorshop_id} key={shop.tailorshop_id}>{shop.tailorshop_id} - {shop.name} ({shop.short_name})</option>
                                );
                            })}
                        </select>


                    </Row>

                    <Row style={{ width: "100%" }}>
                        <Col >
                            <div className="mb-3">
                                <label>Category ID:</label>&nbsp;<br />
                                <input type="text" placeholder="category_id" {...register("category_id", { required: true })} disabled={true} />
                            </div>

                            <div className="mb-3">
                                <label>Category Name:</label>&nbsp;<br />
                                <input type="text" placeholder="name" {...register("name", { required: true })} />
                            </div>
                            <div className="mb-3">
                                <label>Description:</label>&nbsp;<br />
                                <input type="text" placeholder="remark" {...register("remark", { required: false })} />
                            </div>
                            <div className="mb-3">
                                <label>Category Type:</label>&nbsp;<br />
                                <input type="text" placeholder="category_type" {...register("category_type", { required: true })} disabled={true} />
                            </div>
                        </Col>


                        <Col >
                            <div className="mb-3">
                                <label>Parent ID:</label>&nbsp;<br />
                                <input type="text" placeholder="category_parent" {...register("category_parent", {})} />
                            </div>
                            <div className="mb-3">
                                <label>State:</label>&nbsp;<br />
                                <input type="text" placeholder="state" {...register("state", { required: true })} />
                            </div>

                            <div className="mb-3">
                                <label>Owner:</label>&nbsp;<br />
                                <input type="text" placeholder="owner" {...register("owner", { required: true })} />
                            </div>
                            <div className="mb-3">
                                <label>Position:</label>&nbsp;<br />
                                <input type="text" placeholder="pos" {...register("pos", {})} />
                            </div>
                        </Col>
                    </Row>

                    {/* DEBUG:{JSON.stringify(props.userData)} */}
                </Container>
                <button type="submit" className="btn btn-primary btn-sm">Add Category</button>

            </form>
        </div>
    );
}




